import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';

// ----------------------------
// 1️⃣ Firebase Config
// ----------------------------
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// ----------------------------
// 2️⃣ Initialize App Safely
// ----------------------------
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// ----------------------------
// 3️⃣ Initialize Auth
// ----------------------------
export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => console.log('✅ Firebase auth persistence set to LOCAL'))
  .catch((err) => console.error('❌ Error setting persistence:', err));

// ----------------------------
// 4️⃣ Providers
// ----------------------------
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');
